import { useServicesQuery } from '@features/service/queries';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateVisitType } from '../../../../entity';
import { PreviewVisit } from '../../../visit-daily-overview-diagram';
import { useAvailableSlots } from '../../../../schedule/store';

export const useReservationTimeSlots = (
  setPreviewVisit: React.Dispatch<React.SetStateAction<PreviewVisit | undefined>>,
  serviceIds: string | undefined,
) => {
  const { setValue, getValues, control } = useFormContext<CreateVisitType>();
  const date = useWatch({ control, name: 'date' });
  const { data: servicesData } = useServicesQuery();
  const { slots, reason } = useAvailableSlots(date ? dayjs(date) : undefined, serviceIds);

  const resolveServiceName = useCallback(
    () => servicesData?.find(s => s.id === getValues('serviceIds'))?.serviceName,
    [getValues, servicesData],
  );

  const handleSlotClick = useCallback(
    (slot: { start: string; end: string }) => {
      const base = getValues('date');
      const [h, m] = slot.start.split(':');
      const [eh, em] = slot.end.split(':');
      setValue('date', dayjs(base).hour(+h).minute(+m).toDate());
      setValue('dateTo', dayjs(base).hour(+eh).minute(+em).toDate());
      setPreviewVisit({
        startTime: slot.start,
        endTime: slot.end,
        serviceName: resolveServiceName(),
      });
    },
    [getValues, setValue, resolveServiceName, setPreviewVisit],
  );

  return { handleSlotClick, date, slots, reason };
};
